export enum AlertTypesEnum {
    DELAY = 'delay',
    SAFE_ROUTE_DEVIATION = 'safe_route_deviation',
}
